import { toast } from 'sonner';
import { CustomNotification, NotificationType } from './CustomNotification';

export const TYPE_INFO = 'info';
export const TYPE_WARNING = 'warning';
export const TYPE_ERROR = 'error';

export const showNotification = (message: string, type: NotificationType = TYPE_INFO, duration: number = 5000) => {
    return toast.custom(toastId => <CustomNotification type={type} id={toastId} message={message} />, {
        unstyled: true,
        className: 'sysa',
        duration: type === TYPE_ERROR ? Infinity : duration
    });
};
